import React from 'react';
import ToPeso from './ToPeso';
import './ProgressBar.scss';

const ProgressBar = ({ totalPayments, remainingBalance, totalRepayments, totalPenalty }) => {
  // Calculate the payment progress
  const paymentProgress = (totalPayments / totalRepayments) * 100;
  const progressColor = 
    paymentProgress >= 99.99 ? '#28a745' :  // Fully paid - Green
    paymentProgress >= 75 ? '#17a2b8' :   // Above 75% - Blue
    paymentProgress >= 50 ? '#ffc107' :   // Above 50% - Yellow
    paymentProgress >= 25 ? '#fd7e14' :   // Above 25% - Orange
    '#dc3545';                           // Below 25% - Red

  return (
    <div className="payment-progress">
      <div className="progress-header">
        <div className="progress-title">
          <i className="fa-solid fa-chart-line"></i>
          Payment Progress
        </div>
        <div className="progress-amount">
          <ToPeso amount={totalPayments} />
          <span className="separator">/</span>
          <ToPeso amount={totalRepayments} />
        </div>
      </div>

      <div className="progress-wrapper">
        <div 
          className="progress-bar" 
          style={{ 
            width: `${Math.min(paymentProgress, 100)}%`,
            backgroundColor: progressColor 
          }}
        >
          <span className="progress-label">{paymentProgress.toFixed(1)}%</span>
        </div>
      </div>

      <div className="progress-footer">
        <div className="progress-stat">
          <span className="label">Paid</span>
          <span className="value paid">
            <i className="fa-solid fa-circle-check"></i>
            <ToPeso amount={totalPayments} />
          </span>
        </div>
        <div className="progress-stat">
          <span className="label">Balance</span>
          <span className="value remaining">
            <i className="fa-solid fa-circle-exclamation"></i>
            <ToPeso amount={remainingBalance} />
          </span>
        </div>
        <div className="progress-stat">
          <span className="label">Penalty</span>
          <span className="value penalty">
            <i className="fa-solid fa-triangle-exclamation"></i>
            <ToPeso amount={totalPenalty} />
          </span>
        </div>
      </div>
    </div>
  );
};

export default ProgressBar;
